import { Controller } from "@hotwired/stimulus";
// import SimpleBar from "simplebar"

export default class extends Controller {
  static targets = ["sidebar", "toggle"];

  connect() {
    // if (this.element.classList.contains("js-simplebar")) {
    //   // Initialize simplebar
    //   new SimpleBar(this.element)
    // }
  }

  toggle() {
    this.sidebarTarget.classList.toggle("collapsed");

    this.sidebarTarget.addEventListener(
      "transitionend",
      () => {
        window.dispatchEvent(new Event("resize"));
      },
      { once: true }
    ); // Use once: true to ensure the event listener is removed after first execution
  }
}
